import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaMediaFinal = (): TabelaColuna => ({
  Chave: 'mediaFinal',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 130 }}>Média Final</div>
})
